<template>
    <div>
        <div class="row">
            <div class="col">
                <h3>
                    Filtres
                </h3>

                <v-select label="Tag" outlined chips @input="setSelectedTags" :items="tags"
                    no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                    item-text="name" multiple>
                </v-select>

                <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                    @input="setSelectedCategories" item-value="id" item-text="label" multiple>
                </v-select>

                <v-select label="Commune" outlined chips small-chips deletable-chips :items="communes"
                    @input="setSelectedCommunes" :value="selectedCommunes" item-value="id" item-text="label" multiple>
                </v-select>

                <div class="d-flex justify-content-center">
                    <strong class="text-primary my-4">ou</strong>
                </div>

                <v-select label="Sélection Apidae" outlined v-if="account.tis_type.code === 'APIDAE'"
                    :items="apidaeSelections" @input="setSelectedApidaeSelection" :value="selectedApidaeSelection"
                    return-object item-text="libelle.libelleFr">
                </v-select>

                <v-select
                    class="mt-5"
                    v-if="hasEntityAndProvider"
                    label="Sur quel type d'offre souhaitez vous réaliser la campagne d'adhésion ?"
                    outlined
                    :items="[{ label: 'Ma campagne concerne des entités juridiques', value: 'ENT'},
                         { label: 'Ma campagne concerne des objets', value: 'OBJ'}]"
                    @input="setCadhType"
                    :value="cadhType"
                    return-object
                    :class="{'input-error': cadhType === null}"
                    item-text="label">
                </v-select>
            </div>
            <div class="col-12 col-lg-8">
                <h3>
                    Prestataires <div class="badge blue-grey darken-2 text-white">{{ filteredProviders.length }}</div>
                </h3>
                <v-simple-table fixed-header class="border mt-4">
                    <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">Commune</th>
                            <th class="text-left">Destinataire</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="provider in filteredProviders" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>{{ provider.commune }}</td>
                            <td>{{ provider.email }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
        </div>

        <div class="text-right mb-5 mt-5">
            <v-btn class="default-button" @click="setCurrentStep(2)">Passer à l'étape suivante</v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import * as EmailValidator from "email-validator"

export default {
    name: "Filters",
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            panel: [],
            loadingApidaeProviders: false,
            hasEntityAndProvider: false,
            lockSearch: false
        }
    },
    methods: {
        ...mapMutations('createCadh', ['setSelectedCategories', 'setSelectedCommunes', 'setSelectedTags',
            'setProviders', 'setCurrentStep', 'setEmailsValid', 'setEmailsWrong', 'setSelectedApidaeSelection',
            'setCadhType', 'setFilteredProviders', 'setHasEntityAndProvider']),
        getProviders() {
            let payload = {
                categoryIds: this.selectedCategories,
                communeIds: this.selectedCommunes,
                tagIds: this.selectedTags
            }

            this.$http.post('auth/campaigns/providers', payload).then(res => {
                this.setProviders(res.body.data.providers)
                this.setEmailLists()
            })

            this.checkIfHasEntityAndProvider()
        },
        checkIfHasEntityAndProvider() {
            let hasEntity   = this.filteredProviders.find(provider => provider.category === "Entité juridique") !== undefined
            let hasProvider = this.filteredProviders.find(provider => provider.category !== "Entité juridique") !== undefined

            this.hasEntityAndProvider = hasEntity && hasProvider

            if(hasEntity && !hasProvider) {
              this.setCadhType('ENT')
            }

            this.setHasEntityAndProvider(this.hasEntityAndProvider)
        },
        getApidaeProviders() {
            if (this.selectedApidaeSelection !== null) {
                this.loadingApidaeProviders = true

                let payload = {
                    projectId: this.selectedApidaeSelection.projectId,
                    selectionId: this.selectedApidaeSelection.id,
                    selectionName: this.selectedApidaeSelection.nom,
                    disabled: ['DOMAINE_SKIABLE_VTT']
                }
                this.$http.post('auth/account/apidae-selections/providers', payload).then(res => {
                    this.setProviders(res.body.data.providers)
                    this.checkIfHasEntityAndProvider()
                    this.setEmailLists()
                    this.loadingApidaeProviders = false
                })
            }
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = 'Email non renseigné'
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = 'Mauvais format d\'email'
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        }
    },
    computed: {
        ...mapState('account', ['tags', 'categories', 'communes', 'account', 'apidaeSelections']),
        ...mapState('createCadh', ['selectedCategories', 'selectedCommunes', 'selectedTags',
            'providers', 'emailsValid', 'emailsWrong', 'selectedApidaeSelection', 'cadhType']),
        filteredProviders() {
            let filteredProviders = this.providers

            if(this.cadhType !== null) {
                if(this.cadhType.value === "ENT"){
                    filteredProviders = this.providers.filter(provider => {
                        return provider.category === "Entité juridique"
                    })
                } else if(this.cadhType.value === "OBJ"){
                    filteredProviders = this.providers.filter(provider => {
                        return provider.category !== "Entité juridique"
                    })
                }
            }

            this.setFilteredProviders(filteredProviders)

            return filteredProviders
        }
    },
    watch: {
        selectedCategories() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedCategories.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedCommunes() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedCommunes.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedTags() {
            if (!this.lockSearch) {
                this.getProviders()
            }

            if (this.selectedTags.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedApidaeSelection() {
            this.getApidaeProviders()

            this.lockSearch = true

            if(this.cadhType === null) {
              this.setCadhType(null)
            }

            if(this.selectedApidaeSelection !== null) {
                this.setSelectedCommunes([])
                this.setSelectedCategories([])
                this.setSelectedTags([])
            }

            setTimeout(() => {
                this.lockSearch = false
            }, 500)
        },
        cadhType() {
            this.setHasEntityAndProvider(false)
        }
    },
    created() {
        this.$store.dispatch('resource/fetchCategories')
        this.$store.dispatch('account/fetchTags')
        this.$store.dispatch('account/fetchApidaeSelections')

        this.getProviders()
    }
}
</script>